import { setLocale } from '@/utilities/dateUtils';
import { locale } from '../../constants/global';
import UserService from '../users/users.service';
import { SET_LANGUAGE } from './actionTypes';

export const FetchLanguage = (language) => (dispatch) => {
	dispatch({
		type: SET_LANGUAGE,
		language: language,
		messages: locale[language].messages,
	});

	setLocale(locale[language].intl);
};

export const SetLanguage =
	(language, updateUser = true) =>
	(dispatch, getState) => {
		let state = getState();
		let user = {
			...state.auth.user,
		};
		let lang = state.language.list;

		if (language === 'en_US') {
			user.languageId = lang[0].id;
		} else if (language === 'es_ES') {
			user.languageId = lang[1].id;
		}

		dispatch(FetchLanguage(language));
		if (updateUser) {
			const options = {
				id: user.id,
				languageId: user.languageId,
			};

			UserService.update(options);
		}
	};
